import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./hooks/useAuth";
import reportWebVitals from "./reportWebVitals";
import store from "./store";
import { isProductionSiteHost, usesPublicApiProxy } from "./config";

if (
  typeof window !== "undefined" &&
  usesPublicApiProxy() &&
  isProductionSiteHost(window.location.hostname)
) {
  void fetch("/api/warmup", { method: "GET", cache: "no-store" }).catch(() => undefined);
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
